//* Styles
import EmptyThankLottieStyle from './style';

//* Lottie Files
import lottieEmpty from '@/lottieFiles/emptyCart.json';
import success from '@/lottieFiles/success.json';

//* Component
import LottieAnimation from '@/components/LottieAnimation';

const EmptyThankLottie = ({ type }) => {
	return (
		<EmptyThankLottieStyle className={type == 'empty' ? 'empty' : 'success'}>
			<LottieAnimation
				loop
				isPlay
				animData={type == 'empty' ? lottieEmpty : success}
			/>
		</EmptyThankLottieStyle>
	);
};

export default EmptyThankLottie;
